// Main navigation

$(function () {
  const event = $(window).width() > 991 ? 'mouseover' : 'click';

  // Menu categories
  $('.MainNavigation-uglyMenu .MainNavigation-uglyMenu--CategoryToggle').on(event, function (e) {
    e.stopPropagation();
    e.preventDefault();
    if ( !$(this).next('.MainNavigation-uglyMenu--CategoryMenu').hasClass('show') )
    {
      $('.MainNavigation-uglyMenu .MainNavigation-uglyMenu--CategoryMenu').removeClass('show');
      $(this).next('.MainNavigation-uglyMenu--CategoryMenu').addClass('show');
      hideSubmenus();
    }
  });

  // Submenu
  $('.MainNavigation-uglyMenu').parents('.dropdown').on('hidden.bs.dropdown', function(){
    hideSubmenus();
  });

  $('.MainNavigation-uglyMenu--CategoryMenu .MainNavigation-uglyMenu--CategoryMenu--SubmenuToggle').on('click', function(e){
    e.stopPropagation();
    e.preventDefault();
    
    let $toggler = $(e.target);
    let $menu = $toggler.next('.MainNavigation-uglyMenu--CategoryMenu--SubmenuMenu');

    if ( $menu.hasClass('show') )
    {
      $menu.removeClass('show');
    }
    else
    {
      $toggler.parents('.MainNavigation-uglyMenu--CategoryMenu').find('.MainNavigation-uglyMenu--CategoryMenu--SubmenuMenu.show').removeClass('show');
      $menu.addClass('show');
    }
  });

  function hideSubmenus(){
    $('.MainNavigation-uglyMenu .MainNavigation-uglyMenu--CategoryMenu--SubmenuMenu.show').removeClass('show');
  }

  $(window).on('load resize', function () {
    const $collapsible = $('.jsCollapsible');
    if ($(window).width() > 991) {
      $collapsible.addClass('collapse');
    } else {
      $collapsible.removeClass('collapse');
    }
  });
});
